import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Navigate, useNavigate } from "react-router-dom"

import Column from "../../../common/components/Column"
import PasswordTextField from "../../../common/components/PasswordTextField"
import Row from "../../../common/components/Row"
import TextLink from "../../../common/components/TextLink"
import AdminAuthTitle from "../components/AdminAuthTitle"
import AdminLoadingPaper from "../components/AdminLoadingPaper"
import { isAdminDemoMode } from "../mockData"
import {
  adminLogin,
  clearAdminLoginError,
  selectAdminIsLoggingIn,
  selectAdminLoginError,
  selectAdminToken,
} from "../reducer"

export default function AdminLogIn() {
  const [email, setEmail] = useState(
    isAdminDemoMode() ? "admin@onebasecrm.com" : ""
  )
  const [password, setPassword] = useState(isAdminDemoMode() ? "demo" : "")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const token = useSelector(selectAdminToken)
  const isLoggingIn = useSelector(selectAdminIsLoggingIn)
  const loginError = useSelector(selectAdminLoginError)

  useEffect(() => {
    dispatch(clearAdminLoginError())
  }, [dispatch])

  if (token) {
    return <Navigate to="/admin" replace />
  }

  function handleSubmit(e) {
    e.preventDefault()
    dispatch(adminLogin({ email, password })).then((result) => {
      if (adminLogin.fulfilled.match(result)) {
        navigate("/admin")
      }
    })
  }

  return (
    <AdminLoadingPaper isLoading={isLoggingIn}>
      <AdminAuthTitle
        title="Welcome back"
        subtitle="Sign in to the Admin panel."
      />
      <form onSubmit={handleSubmit} style={{ width: "100%" }}>
        <Column gap={2.5}>
          {isAdminDemoMode() && (
            <TextField
              size="small"
              value="Demo mode — any credentials work"
              disabled
              fullWidth
            />
          )}
          <TextField
            label="Email Address"
            type="email"
            size="small"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!loginError}
            helperText={loginError}
            required
            fullWidth
          />
          <PasswordTextField
            label="Password"
            size="small"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            fullWidth
          />
          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={!email || !password || isLoggingIn}
            fullWidth
            sx={{ mt: 1, borderRadius: 3 }}
          >
            Log In
          </Button>
          <Row sx={{ justifyContent: "center", mt: 1 }}>
            <TextLink to="/admin/forgot-password/" text="Forgot password?" />
          </Row>
        </Column>
      </form>
    </AdminLoadingPaper>
  )
}
